export default {
      id: "send-to-cloud-usage",
      viewBox: "0 0 17 16",
      url: __webpack_public_path__ + "img/icons.svg#send-to-cloud",
      toString: function () {
        return this.url;
      }
    }